import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ResetPasswordDataService {
  private email: string | null = null;
  private vcode: number | null = null;

  setEmail(email: string) {
    this.email = email;
  }

  getEmail(): string | null {
    return this.email;
  }

  setVcode(vcode: number) {
    this.vcode = vcode;
  }

  getVcode(): number | null {
    return this.vcode;
  }

}
